import api from "./api";
import { AddCostObj } from "../GlobalTypes";
import { DealerInfoState } from "../components/dealerZone/Insights/Tab/InsightsTab";
import { RepStats } from "../components/dealerZone/Insights/InsightsDealerRepTotals";
import { URLState } from "../components/dealerZone/Insights/Tab/InsightsTab";

async function generatePDF(pdfArg: {
  poNumber: string;
  quoteId: string;
  grandTotal: string;
  isOrder: boolean;
  salesOrder: string;
  isProduction: boolean;
  series: string;
  dealerTax: number;
  codOrTerms: string;
  region: string;
}) {
  return await api.post("/api/getPDF", pdfArg, { responseType: "blob" });
}

async function generateCustomerPDF(pdfArg: {
  poNumber: string;
  quoteId: string;
  grandTotal: string;
  isOrder: boolean;
  dealerTax: number;
  hidePricing: string;
  salesTax: number;
  margin: number;
  withMarkup: boolean;
  addCosts: AddCostObj[];
  dealerLogo: string;
  deliveryMarkup: boolean;
  crateFreightMarkup: boolean;
}) {
  return await api.post("/api/getPDFCustomer", pdfArg, {
    responseType: "blob",
  });
}

async function generateTablePDF(pdfArg: {
  quoteId: string;
  pdfLabel: string;
  dealerTax: number;
  codOrTerms: string;
  region: string;
}) {
  return await api.post("/api/getTablePDF", pdfArg, { responseType: "blob" });
}

async function generateShippingLabelsPDF(pdfArg: {
  quoteId: string;
  qrCode: string;
  isCustom?: boolean;
  labelData?: any[];
  customSO?: string;
  customPO?: string;
  customDealer?: string;
}) {
  return await api.post("/api/getShippingLabelsPDF", pdfArg, {
    responseType: "blob",
  });
}

async function generateCNCLabelPDF(labelData: any[], salesOrder: string) {
  return await api.post(
    "/api/getCNCLabelsPDF",
    {
      labelData,
      salesOrder,
    },
    { responseType: "blob" }
  );
}

async function generateOrderSheetPDF(quoteId: string) {
  return await api.post(
    "/api/getOrderSheetPDF",
    {
      quoteId,
    },
    { responseType: "blob" }
  );
}

async function sendOrderAcknowledgement(quoteId: string, salesOrder: string) {
  return await api.post("/api/orderAcknowledgement", { quoteId, salesOrder });
}

async function generateOrderAckPDF(quoteId: string, salesOrder: string) {
  return await api.post(
    "/api/getOrderAckPDFPreview",
    {
      quoteId,
      salesOrder,
    },
    { responseType: "blob" }
  );
}

type TotalsType = {
  status: string;
  bifold: string;
  bifoldCount: number;
  corner: string;
  cornerCount: number;
  window: string;
  windowCount: number;
  fixed: string;
  fixedCount: number;
  slider: string;
  sliderCount: number;
  swing: string;
  swingCount: number;
  pivot: string;
  pivotCount: number;
  total: string;
  count: number;
};

type Top3Type = {
  order: number;
  bifold: string;
  corner: string;
  fixed: string;
  pivot: string;
  slider: string;
  swing: string;
  window: string;
};

interface CustomerInsightsProps {
  dealer: string;
  rep: string;
  repEmail: string;
  dealerLogo: string;
  dateRange: string;
  startDate: string | Date;
  endDate: string | Date;
  dealerInfo: DealerInfoState;
  territory: string;
  tableData: { totals: TotalsType[]; top3: Top3Type[] };
  repStats: RepStats[] | undefined;
  url: URLState;
}

async function generateInsightsPDF(
  insightsObj: Omit<CustomerInsightsProps, "repEmail">
) {
  return await api.post("/api/getInsightsPDF", insightsObj, {
    responseType: "blob",
  });
}

export {
  generatePDF,
  generateCustomerPDF,
  generateTablePDF,
  generateShippingLabelsPDF,
  generateCNCLabelPDF,
  generateOrderSheetPDF,
  sendOrderAcknowledgement,
  generateOrderAckPDF,
  generateInsightsPDF,
};
